var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6615 1.67188H4.99479C4.55276 1.67188 4.12884 1.84747 3.81628 2.16003C3.50372 2.47259 3.32813 2.89651 3.32812 3.33854V16.6719C3.32813 17.1139 3.50372 17.5378 3.81628 17.8504C4.12884 18.1629 4.55276 18.3385 4.99479 18.3385H14.9948C15.4368 18.3385 15.8607 18.1629 16.1733 17.8504C16.4859 17.5378 16.6615 17.1139 16.6615 16.6719V6.67188L11.6615 1.67188Z",
    stroke: "#212A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3385 14.1719H6.67188",
    stroke: "#212A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3385 10.8281H6.67188",
    stroke: "#212A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33854 7.5H7.50521H6.67188",
    stroke: "#212A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 1.67188V6.67187H16.6719",
    stroke: "#212A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBlock);
export default __webpack_public_path__ + "static/media/pdf-block.0fe2a73ded271f41212b6f294ac75f77.svg";
export { ForwardRef as ReactComponent };